import _ from 'lodash';
import Store from './Store';
import mockTemplates from '../containers/__mocks__/templates.json';

export default class Template extends Store {
  store = {
    _id: null, 
    name: null, 
    blurb: null, 
    parents: [], 
    sessions: [], 
  }
  
  constructor(props) {
    super(props);
    return this.setup(props);
  }

  static mock() {
    const mockTemplate = _.cloneDeep(mockTemplates[4])

    return new Template({
      _id: mockTemplate._id, 
      name: mockTemplate.name, 
      blurb: mockTemplate.blurb, 
      parents: mockTemplate.parents, 
      sessions: mockTemplate.sessions.map(v => v.template = v)
    });
  }

  static isTemplate(obj) {
    return obj instanceof Template;
  }
}


// WEBPACK FOOTER //
// ./src/models/Template.js